import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import ScrollToTop, { SchemaJsonLd, useCursorHover } from "@/components/utils";
import { useLenis } from "@/lib/useLenis";
import { BUSINESS } from "@/lib/data";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Bridal from "@/pages/Bridal";
import Gallery from "@/pages/Gallery";
import Reviews from "@/pages/Reviews";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";
import Book from "@/pages/Book";

function PageTransition({ children }) {
  const { pathname } = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
      >
        {children}
      </motion.div>
    </AnimatePresence>
  );
}

function Shell() {
  useLenis();
  useCursorHover();
  return (
    <>
      <ScrollToTop />
      <Nav />
      <main className="relative">
        <PageTransition>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/bridal" element={<Bridal />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/reviews" element={<Reviews />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/book" element={<Book />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </PageTransition>
      </main>
      <Footer />
      <Toaster
        position="bottom-center"
        toastOptions={{
          style: {
            background: "#1B1B1B",
            color: "#F3EAD9",
            border: "1px solid #C89B3C",
            borderRadius: 0,
          },
        }}
      />
      <SchemaJsonLd business={BUSINESS} />
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Shell />
      </BrowserRouter>
    </div>
  );
}
